import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { actions, Control, Errors, Form } from "react-redux-form";
import {
  Button,
  Checkbox,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Radio,
  Row,
} from "react-bootstrap";
import RequiredInput from "../common/form/elements/required-input";
import InlineCKEditor from "../common/editor/inline-editor";
import PageTitle from "../common/page-title/index";
import { isLoggedIn } from "../../utils/tokenUtils";
import { getOutlets, updateOutlet } from "../../actions/outlet";
import { loadPageContent } from "../../actions/content";
import TextViewer from "../common/editor/text-viewer";

import "./style.css";
import VoucherSelect from "../store-summary/voucher-select";

class YourStoreForm extends Component {
  handleSubmit = (payLoad) => {
    const { dispatch } = this.props;
    dispatch(
      actions.submitFields(
        "deep.yourStore",
        updateOutlet(payLoad, this.state.addMore, this.props.registration)
      )
    );
  };
  handleAddMore = (event) => {
    this.setState({
      addMore: event.target.value === "true",
    });
  };
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  handlePfpChange = () => {
    this.props.dispatch(actions.change("deep.yourStore.voucher_type_id", ""));
  };

  constructor(props) {
    super(props);

    this.pageSlug = "your-store";
    this.state = {
      addMore: "",
    };
  }

  componentWillMount() {
    if (this.props.registration.pending && this.props.registration.internal) {
      this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
    }

    if (this.props.registration.internal) {
      this.props.dispatch(getOutlets(this.props.registration.pending));
    }
  }

  componentDidMount() {
    this.props.dispatch(actions.reset("deep.yourStore.voucher_type_id"));
  }

  render() {
    const {
      pfpSelect,
      registration: { pending, internal },
      vouchers,
      rewardMarkup,
    } = this.props;
    if (!(this.props.eircode || this.props.passcode)) {
      if (isLoggedIn()) {
        return <Redirect to="/outlet" />;
      } else {
        return <Redirect to="/registration/outlet" />;
      }
    } else {
      const formFields = (
        <Col lg={6}>
          <FormGroup controlId="customer_number">
            <ControlLabel>Customer number</ControlLabel>
            <Control.text
              readOnly
              model=".customer_number"
              value={this.props.customer_number}
              component={FormControl}
            />
          </FormGroup>
          <Errors
            show={{ focus: false }}
            className="errors"
            model=".customer_number"
            messages={{
              customer_number: "This field is required",
            }}
          />

          <RequiredInput
            model=".updated_name"
            inputType="text"
            label="Store name"
            controlId="name"
          />

          <RequiredInput
            model=".updated_address_1"
            inputType="text"
            label="Address line 1"
            controlId="address_1"
          />

          <FormGroup controlId="address_2">
            <ControlLabel>Address line 2</ControlLabel>
            <Control.text model=".updated_address_2" component={FormControl} />
          </FormGroup>
          <Errors
            show={{ focus: false }}
            className="errors"
            model=".updated_address_2"
            messages={{
              updated_address_2: "This field is required",
            }}
          />
          <FormGroup controlId="address_3">
            <ControlLabel>Address line 3</ControlLabel>
            <Control.text model=".updated_address_3" component={FormControl} />
          </FormGroup>
          <Errors
            show={{ focus: false }}
            className="errors"
            model=".updated_address_3"
            messages={{
              updated_address_3: "This field is required",
            }}
          />

          <RequiredInput
            model=".updated_town"
            inputType="text"
            label="Town/city"
            controlId="town"
          />

          <RequiredInput
            model=".updated_county"
            inputType="text"
            label="County"
            controlId="county"
          />

          <FormGroup controlId="updated_eircode">
            <ControlLabel>Eircode*</ControlLabel>
            <Control.text
              disabled={this.props.dont_know_eircode}
              model=".updated_eircode"
              component={FormControl}
            />
          </FormGroup>

          <Errors
            show={(field) => !field.focused && !this.props.dont_know_eircode}
            className="errors"
            model=".updated_eircode"
            messages={{
              updated_eircode: "This field is required",
            }}
          />

          <FormGroup controlId="dont_know_eircode">
            <Control.checkbox model=".dont_know_eircode" component={Checkbox}>
              I do not know my eircode
            </Control.checkbox>
          </FormGroup>

          {this.props.pfp && (
            <Control.checkbox
              model=".pfp"
              component={Checkbox}
              onChange={this.handlePfpChange}
            >
              This store is eligible to earn rewards. Please read and accept the
              reward{" "}
              <Link to="/content-pages/rewards-terms-conditions" target="_blank">
                terms & conditions
              </Link>
              .
            </Control.checkbox>
          )}

          <FormGroup controlId="addMore">
            <ControlLabel>
              Do you have any more stores to add to your account?
            </ControlLabel>
            <div>
              <Radio
                value="true"
                name="addMore"
                onChange={this.handleAddMore}
                checked={this.state.addMore === true}
                inline
                className="pull-left"
              >
                Yes
              </Radio>
              <Radio
                value="false"
                name="addMore"
                onChange={this.handleAddMore}
                checked={this.state.addMore === false}
                inline
                className="pull-left"
              >
                No
              </Radio>
            </div>
          </FormGroup>

          <Control type="hidden" model=".eircode" />
          <Control
            type="hidden"
            model=".customer_number"
            value={this.props.customer_number}
          />

          {pfpSelect && pending && internal && +rewardMarkup < 100 && (
            <div className="mg-top-20">
              <VoucherSelect vouchers={vouchers} staffReward={true} />
            </div>
          )}

          <Button
            type="submit"
            className="btn red-ghost-btn pull-right"
            disabled={!(this.props.formValid && !(this.state.addMore === ""))}
          >
            Next
          </Button>
        </Col>
      );

      return (
        <Grid className="your-store-container">
          <Row>
            <Col lg={12}>
              <PageTitle>Your store</PageTitle>
            </Col>
          </Row>
          {pending && internal && (
            <Row>
              <Col lg={12}>
                <InlineCKEditor
                  identifier={`${this.pageSlug}_content_text`}
                  onContentSaved={this.handleContentSaved}
                  contents={
                    this.props.contents[`${this.pageSlug}_content_text`]
                  }
                />
              </Col>
            </Row>
          )}
          {!(pending && internal) && (
            <TextViewer pageSlug="your-store"></TextViewer>
          )}
          <Row>
            <Col md={12}>
              <Errors className="errors" model="deep.yourStore" />
            </Col>
          </Row>
          <Row className="show-grid your-store-form">
            <Form model="deep.yourStore" onSubmit={this.handleSubmit}>
              {formFields}
            </Form>
          </Row>
        </Grid>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    vouchers: state.stores.vouchers,
    pfpSelect: state.deep.yourStore.pfp,
    rewardMarkup: state.deep.yourStore.reward_markup,
    eircode: state.aboutYou.outlet.eircode,
    passcode: state.aboutYou.outlet.passcode,
    customer_number: state.aboutYou.outlet.customer_number || "",
    pfp: state.aboutYou.outlet.reward_store,
    registration: state.registration,
    dont_know_eircode: state.deep.yourStore.dont_know_eircode,
    formValid: state.deep.forms.yourStore.$form.valid,
    contents: state.content.list,
  };
};

export default connect(mapStateToProps)(YourStoreForm);



// WEBPACK FOOTER //
// ./src/components/your-store/index.jsx